import { motion } from "framer-motion";
import FONDO from "../assets/ciudad.svg";
import CARRO from "../assets/carro.svg";
import AVIONCITO from "../assets/avioncito.svg";
import PING from "../assets/ping.svg";

const SectionOne = () => {
  return (
    <div
      className="relative w-full h-[75vh] overflow-hidden bg-cover bg-center"
      style={{ backgroundImage: `url(${FONDO})` }}
    >
      {/* Carro: izquierda → derecha */}
      <motion.img
        src={CARRO}
        alt="carro"
        className="absolute bottom-0 left-0 w-40 md:w-96"
        initial={{ x: "-100%" }}
        animate={{ x: "75%" }}
        transition={{ duration: 6, ease: "linear" }}
      />

      {/* Avion: derecha → izquierda */}
      <motion.img
        src={AVIONCITO}
        alt="avion"
        className="absolute top-10 right-0 w-28 md:w-40"
        initial={{ x: "100%" }}
        animate={{ x: "-140%" }}
        transition={{ duration: 8, ease: "linear" }}
      />

      {/* Ping arriba del carro */}
      <motion.img
        src={PING}
        alt="ping"
        className="absolute bottom-32 left-1/2 w-12 md:w-16"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2, duration: 1 }}
      />

      {/* Textos: derecha → izquierda */}
      <div className="absolute inset-0 flex flex-col items-end justify-center px-6 md:px-20">
        <motion.h1
          className="text-2xl md:text-4xl text-sky-700 font-bold leading-tight text-right"
          initial={{ x: "100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        >
          Expertos en llevartelo que más{" "}
          <strong className="text-sky-400">Necesitas</strong>
        </motion.h1>

        <motion.p
          className="text-base md:text-lg font-light text-sky-700 text-right max-w-xl"
          initial={{ x: "100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut", delay: 0.5 }}
        >
          Brindar estrategias integrales para la solución de problemas en
          empresas mexicanas e internacionales
        </motion.p>
      </div>
    </div>
  );
};

export default SectionOne;
